import React, { useState, useEffect } from 'react';
import { db } from "../firebase";
import { doc, getDoc, updateDoc, onSnapshot } from "firebase/firestore";

const ActivarDirecto = () => {
  const [estaActivo, setEstaActivo] = useState(false);
  const [loading, setLoading] = useState(true);

  // Referencia al documento de configuración
  const retoRef = doc(db, "configuracion", "reto");

  useEffect(() => {
    // Escuchamos el estado actual en tiempo real
    const unsub = onSnapshot(retoRef, (docSnap) => {
      if (docSnap.exists()) {
        setEstaActivo(docSnap.data().directoActivo);
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const toggleDirecto = async () => {
    try {
      await updateDoc(retoRef, {
        directoActivo: !estaActivo
      });
    } catch (error) {
      console.error("Error actualizando el estado:", error);
      alert("No tienes permisos para cambiar esto");
    }
  };

  if (loading) return <p>Cargando panel de control...</p>;

  return (
    <div style={{
      padding: '20px',
      background: '#f4f4f4',
      borderRadius: '15px',
      border: '1px solid #ddd',
      textAlign: 'center',
      marginTop: '20px'
    }}>
      <h3 style={{ color: '#3b203b', marginBottom: '15px' }}>Control del Directo</h3>
      
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
        <span style={{ 
          fontWeight: 'bold', 
          color: estaActivo ? '#ff0055' : '#888' 
        }}>
          {estaActivo ? "● EL RETO ESTÁ EN VIVO" : "○ RETO APAGADO"}
        </span>
        
        <button 
          onClick={toggleDirecto}
          style={{
            padding: '10px 20px',
            backgroundColor: estaActivo ? '#333' : '#ff0055',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          {estaActivo ? "Finalizar Directo" : "Activar Directo"}
        </button>
      </div>
    </div>
  );
};

export default ActivarDirecto;